function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import { isBlank } from '../core/regex.js';
import { registerMethods } from '../../utils/methods.js';
// Dynamic style generator
export function css(style, val) {
    var ret = {};
    if (arguments.length === 0) {
        // get full style as object
        this.node.style.cssText.split(/\s*;\s*/).filter(function(el) {
            return !!el.length;
        }).forEach(function(el) {
            var t = el.split(/\s*:\s*/);
            ret[t[0]] = t[1];
        });
        return ret;
    }
    if (arguments.length < 2) {
        // get style properties as array
        if (Array.isArray(style)) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = style[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var name = _step.value;
                    var cased = name;
                    ret[name] = this.node.style.getPropertyValue(cased);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return ret;
        }
        // get style for property
        if (typeof style === 'string') {
            return this.node.style.getPropertyValue(style);
        }
        // set styles in object
        if ((typeof style === "undefined" ? "undefined" : _type_of(style)) === 'object') {
            for(var name1 in style){
                // set empty string if null/undefined/'' was given
                this.node.style.setProperty(name1, style[name1] == null || isBlank.test(style[name1]) ? '' : style[name1]);
            }
        }
    }
    // set style for property
    if (arguments.length === 2) {
        this.node.style.setProperty(style, val == null || isBlank.test(val) ? '' : val);
    }
    return this;
}
// Show element
export function show() {
    return this.css('display', '');
}
// Hide element
export function hide() {
    return this.css('display', 'none');
}
// Is element visible?
export function visible() {
    return this.css('display') !== 'none';
}
registerMethods('Dom', {
    css: css,
    show: show,
    hide: hide,
    visible: visible
});
